const ENV = 'prd'

let domain, plutuscatApi, primeApi

if (ENV == 'test') {
    domain = 'https://mgw-daily.zhongan.com'
    plutuscatApi = `${domain}/appapi/za-plutuscat`
    primeApi = `${domain}/appapi/za-prime`
} else if (ENV == 'pre') {
    domain = "https://gwbk-uat.zhongan.com";
    plutuscatApi = 'https://gwbk-uat.zhongan.com/appapi/za-plutuscat';
    primeApi = "https://gwbk-uat.zhongan.com/appapi/za-prime";
} else if (ENV == 'prd') {
    domain = 'https://gwbk.zhongan.com'
    plutuscatApi = 'https://gwbk.zhongan.com/appapi/za-plutuscat'
    primeApi = 'https://gwbk.zhongan.com/appapi/za-prime'
}

export default {

    // 获取签到 状态
    GetSignHistory() {
        return $.ajax({
            url: `${plutuscatApi}/sign-signAjax-getSignHistory`,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {}
        })
    },

    // 签到操作
    SignIn(data = {}) {
        return $.ajax({
            url: `${domain}/dmapi/za-karma/api-signIn`,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                accessKey: _zax.cookie.get('zaLoginCookieKey'),
            },
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: JSON.stringify(data)
        })
    },

    // 7天签到任务
    GetTask() {
        return $.ajax({
            url: `${plutuscatApi}/sign-signAjax-getTask`,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {}
        })
    },

    // 积分任务查询
    findTask() {
        return $.ajax({
            url: `${plutuscatApi}/open-WebService-findTask`,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {}
        })
    },

    // 任务领取积分
    FinishTask(code) {
        return $.ajax({
            url: `${plutuscatApi}/sign-signAjax-finishTask?code=${code}`,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {}
        })
    },

    // 积分任务领取
    getPoint() {
        return $.ajax({
            url: `${plutuscatApi}/task-task-getPoint`,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {}
        })
    },

    // 积分商城兑换商品查询
    FindPointActivity(code) {
        // let params = { code };
        // params = JSON.stringify(params);
        return $.ajax({
            url: `${plutuscatApi}/open-WebService-findPointActivity?code=${code}`,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {}
        })
    },

    /**
     * 奖金池活动奖励查询
     */
    BonusGetActivityByAccount() {
        return $.ajax({
            url: `${plutuscatApi}/sign-signAjax-getActivityRecordByAccount?actCode=signAward`,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {}
        })
    },

    // 奖金池是否开启
    getActivity(code) {
        return $.ajax({
            url: `${plutuscatApi}/sign-signAjax-getActivity?actCode=signAward`,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {}
        })
    },

    /**
     * 获奖列表
     */
    GetActivityRecord(start, limit) {
        return $.ajax({
            url: `${plutuscatApi}/sign-signAjax-getActivityRecord?actCode=signAward&start='+start+'&limit='+limi`,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {}
        })
    },

    /**
     *奖金池领取奖励
     */
    GetBonusAjax() {
        return $.ajax({
            url: `${plutuscatApi}/sign-signAjax-getActivityPoint?actCode=signAward`,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {}
        })
    },

    /**
     *查询用户信息
     */
    GetPrimePoint(accountId) {
        let params = {
            accountId
        }
        params = JSON.stringify(params)
        return $.ajax({
            url: `${primeApi}/prime-point`,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            xhrFields: {
                withCredentials: true
            },
            type: 'POST',
            datatype: 'json',
            data: params
        })
    },

    GetPrimeBanner(cmsCode) {
        let params = {
            cmsCode
        }
        params = JSON.stringify(params)
        return $.ajax({
            url: `${primeApi}/prime-cms`,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            xhrFields: {
                withCredentials: true
            },
            type: 'POST',
            datatype: 'json',
            data: params
        })
    },
    QueryUserPointInfo() {
        let params = {
            activityId: 100160001,
            activityType: 7,
            accessKey: _zax.cookie.get('zaLoginCookieKey')
        }
        // params = JSON.stringify(params);
        return $.ajax({
            url: `${plutuscatApi}/point-StockAction-queryUserPointInfo`,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            xhrFields: {
                withCredentials: true
            },
            type: 'GET',
            datatype: 'json',
            data: params
        })
    },
    getProductByCode(resourceCode) {
        let params = {
            resourceCode
        }
        // params = JSON.stringify(params);
        return $.ajax({
            url: `${domain}/appapi/za-mars-api/cms-getResourceContentByResourceCode`,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            xhrFields: {
                withCredentials: true
            },
            type: 'POST',
            datatype: 'JSON',
            data: JSON.stringify(params)
        })
    },

    // 查询反欺诈接口
    getUserCredit(data = {}) {
        return $.ajax({
            url: `${domain}/dmapi/za-karma/api-newcomer`,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                accessKey: _zax.cookie.get('zaLoginCookieKey'),
            },
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: JSON.stringify(data)
        })
    },
    userLogin(phone, smsCode) {
        let params = Object.assign({}, {
            phone,
            smsCode,
            shareOrigin: '',
            ticket: _zax.cookie.get('dmAccountTicket'),
            channel: 8,
        });
        return $.ajax({
            url: `${domain}/appapi/dm-account/otp/registerAndLogin`,
            headers: {
                // 'Content-Type': 'application/json;charset=UTF-8',
                accessKey: _zax.cookie.get('zaLoginCookieKey'),
            },
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            // data: JSON.stringify(params)
            data: params

        })
    },
    async sendVerifyCode(phone) {
        //获取验证码
        return $.ajax({
            url: `${domain}/appapi/dm-account/otp/sendSmsCode`,
            headers: {
                accessKey: _zax.cookie.get('zaLoginCookieKey'),
            },
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            dataType: 'json',
            data: {
                phone
            }
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/service.js